import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { BUILD_DEFAULT_THEME } from '../config/theme'

export const THEME_STORAGE_KEY = 'koh-design-theme'

export const useThemeStore = defineStore('theme', () => {
  const theme = ref(BUILD_DEFAULT_THEME)

  const isDark = computed(() => theme.value === 'dark')

  function applyToDocument() {
    document.documentElement.dataset.theme = theme.value
  }

  function init() {
    try {
      const stored = localStorage.getItem(THEME_STORAGE_KEY)
      if (stored === 'light' || stored === 'dark') {
        theme.value = stored
      }
    } catch {
      // localStorage unavailable — keep build default
    }
    applyToDocument()
  }

  function setTheme(next) {
    if (next !== 'light' && next !== 'dark') return
    theme.value = next
    try {
      localStorage.setItem(THEME_STORAGE_KEY, next)
    } catch {
      // ignore
    }
    applyToDocument()
  }

  function toggle() {
    setTheme(theme.value === 'dark' ? 'light' : 'dark')
  }

  return { theme, isDark, init, setTheme, toggle, applyToDocument }
})
